import React from 'react'
import  RadioList from 'saur_ui_library/src/Molecules/RadioList/RadioList';
import Container from 'saur_ui_library/src/Atoms/Container/Container';
import Word from "saur_ui_library/src/Atoms/Word/Word";
function RadioListComponent(props: any) {
  return (
    <Container className={props.className} >
    <Word
            variant="p"
            textStyle="normalBold"
            value={props.value}
            className={props.wordClassName}
          />
         <RadioList
            className={props.radioClassName ? props.radioClassName : props.className}
            selected={props.selected}
            onChange={props.onChange}
            values={props.values}
          />
    </Container>
  )
}

export default RadioListComponent